import { useMemo } from 'react'
import { combineClassNames } from '../helpers/utils'

export interface IStatusItemProps {
  message: string
  icon?: string | React.ReactNode,
  render?:()=>(React.ReactNode | null | undefined),
  slotProps?: {
    root?: React.HtmlHTMLAttributes<HTMLDivElement>
    container?: React.HtmlHTMLAttributes<HTMLDivElement>
    icon?: React.HtmlHTMLAttributes<HTMLImageElement>
    message?: React.HtmlHTMLAttributes<HTMLParagraphElement>
  }
}

const StatusItem = ({ message, icon,render,slotProps = {} }: IStatusItemProps) => {
  // use animation here
  const renderStatusItem = render?.();
  return (
    <div
      {...slotProps.root}
      className={combineClassNames('status_root', slotProps.root?.className)}
    >
      {renderStatusItem ? renderStatusItem : (<div
        {...slotProps.container}
        className={combineClassNames(
          'status_icon_text_container',
          slotProps.container?.className,
        )}
      >
        {icon &&
          (typeof icon === 'string' ? (
            <img
              src={icon}
              {...slotProps.icon}
              style={{ width: 40, height: 40, ...slotProps.icon?.style }}
            />
          ) : (
            icon
          ))}
        <p
          {...slotProps.message}
          className={combineClassNames(
            'status_message_style',
            slotProps.message?.className,
          )}
        >
          {message}
        </p>
      </div>)}
    </div>
  )
}

export default StatusItem
